import SchedulesService from 'js/services/api/schedules/by_stops.js'

import template from './index.pug'

// @vue/component
export default Vue.extend({
  name: 'sub-line-schedules-page',
  template: template(),
  props: {
    sublineId: {
      type: String,
      default: undefined
    },
    sublineRouteIds: {
      type: Array,
      default: undefined
    },
    stops: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      originStopId: undefined,
      destinationStops: [],
      destinationStopId: undefined,
      date: moment().toDate(),
      schedules: [],
      alreadyQuery: false
    }
  },

  computed: {
    datepickerConfig() {
      const currentLocale = Vue.i18n.locale;
      const calendarLocales = Vue.i18n.locales || {};

      return {
        allowInput: true,
        formatDate(date) { return moment(date).format('DD/MM/YYYY') },
        parseDate(date) { return moment(date, 'DD/MM/YYYY').toDate() },
        disableMobile: true,
        locale: calendarLocales[currentLocale] || 'default'
      }
    },

    originStopsOptions() {
      return this.stopsToOptions(this.stops)
    },

    hasDestinationsStops() {
      return this.destinationStops.length !== 0
    },

    destinationStopsOptions() {
      return this.stopsToOptions(this.destinationStops)
    },

    disabledSearch() {
      return !(this.originStopId && this.date && this.destinationStopId)
    },

    computedSchedules() {
      const format = 'D-MMM HH:mm'
      return this.schedules.map(schedule => ({
        id: schedule.id,
        start_time: moment.unix(schedule.epoch).utc().format(format),
        duration: schedule.duration,
        arrival_time: moment.unix(schedule.epoch + schedule.duration).utc().format(format)
      }))
    },

    originStopRouteIds() {
      return this.stops.find(
        stop => stop.id === this.originStopId
      ).route_ids
    }
  },

  watch: {
    stops() {
      this.originStopId = undefined
      this.destinationStopId = undefined
    },

    originStopId() {
      this.getDestinationStops()
    }
  },

  methods: {
    async getSchedules() {
      const params = {
        date: this.date.toString(),
        origin_stop_id: this.originStopId,
        destination_stop_id: this.destinationStopId,
        subline_id: this.sublineId
      }

      this.schedules = await SchedulesService.index(params)
      this.alreadyQuery = true
    },

    getDestinationStops() {
      const route_ids = this.originStopRouteIds.filter(
        route_id => this.sublineRouteIds.includes(route_id)
      )

   
      this.destinationStops = this.stops.filter(stop => stop.route_ids.some(
        route_id => route_ids.includes(route_id)
      ) && stop.id !== this.originStopId)

      this.checkDestinationStopId()
    },

    checkDestinationStopId() {
      if (!this.destinationStopId) { return }

      const destinationStopIds = this.destinationStops.map(stop => stop.id)

      if (destinationStopIds.includes(this.destinationStopId)) { return }

      this.destinationStopId = undefined
    },

    stopsToOptions(stops) {
      return stops.map(stop => ({
        label: `${stop.display_code} | ${stop.name}`,
        value: stop.id
      }))
    }
  }
})
